/* Napurel footer: promise slider (phones). Native scroll-snap + dots + gentle autoplay that stops on touch. */
(function () {
  if (customElements.get('pp-footer-usps')) return;

  class PpFooterUsps extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-pp-ft-track]');
      this.dots = Array.from(this.querySelectorAll('.pp-ft-usps__dot'));
      this.slides = Array.from(this.track.children);
      this.index = 0;
      this.interval = Number(this.dataset.interval) || 4000;
      if (this.slides.length < 2) return;

      this.dots.forEach((dot) =>
        dot.addEventListener('click', () => {
          this.stop();
          this.go(Number(dot.dataset.index));
        })
      );

      let raf = 0;
      this.track.addEventListener(
        'scroll',
        () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.syncFromScroll());
        },
        { passive: true }
      );
      ['pointerdown', 'touchstart', 'focusin'].forEach((type) =>
        this.addEventListener(type, () => this.stop(), { passive: true })
      );

      this.mq = window.matchMedia('(max-width: 749px)');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(([entry]) => (entry.isIntersecting ? this.start() : this.pause()));
        this.io.observe(this);
      }
    }

    disconnectedCallback() {
      this.pause();
      if (this.io) this.io.disconnect();
    }

    syncFromScroll() {
      const w = this.track.clientWidth || 1;
      const i = Math.round(this.track.scrollLeft / w);
      if (i !== this.index) this.setActive(i);
    }

    setActive(i) {
      this.index = Math.max(0, Math.min(this.slides.length - 1, i));
      this.dots.forEach((d, n) => {
        d.classList.toggle('is-active', n === this.index);
        if (n === this.index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    go(i) {
      this.setActive(i);
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
    }

    start() {
      if (this.stopped || this.timer || !this.mq.matches) return;
      this.timer = setInterval(() => this.go((this.index + 1) % this.slides.length), this.interval);
    }

    pause() {
      clearInterval(this.timer);
      this.timer = null;
    }

    stop() {
      this.stopped = true;
      this.pause();
    }
  }

  customElements.define('pp-footer-usps', PpFooterUsps);
})();
